/* 
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */

app.service('_$toast', function($mdToast) {
    
    var TIME=3000;
    var enable=true;
    
    var doEnable=function(){
        
        enable=true;
    };
    
    
    getSimpleToast=function(text){
      
       return $mdToast.simple()
        .textContent(text)
        .position('bottom right')
        .hideDelay(TIME);

    };
    
    this.message = function (text) {
        
        if (!enable)
        return;    
        
        enable=false;
        
        //additional enable
        setTimeout(function(){ doEnable(); },TIME/3);
        
        return $mdToast.show( getSimpleToast(text) ).then(doEnable);
    };
    
    
    this.error=function(text){
        if (!enable)
        return;    
        
        enable=false;
        
        //additional enable
        setTimeout(function(){ doEnable(); },TIME/3);
        return $mdToast.show( getSimpleToast(text).toastClass("error") ).then(doEnable);
    };
    
    this.success=function(text){
        if (!enable)
        return;    
        
        enable=false;
        
        //additional enable
        setTimeout(function(){ doEnable(); },TIME/3);
        return $mdToast.show( getSimpleToast(text).toastClass("success") ).then(doEnable);
    };
    
    //remove that ealier
    window.toast=this;
    
});

